module.exports = __webpack_public_path__ + "img/favicon.5e524461.png";